/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { getCodeCss } from '../getCodeCss/getCodeCss';
import { getStylesImport } from '../getStylesImport/getStylesImport';
import { groupByInstallPackage } from '../groupByInstallPackage/groupByInstallPackage';
import type { EditorOptions } from '../../components/SnippetsContainer/Snippets/types';
import type { InstallMethod } from '../../constants/installation';

export type GetCodeCssAngularArgs = {
	editorOptions: EditorOptions;
	selectedInstallMethod: InstallMethod;
};

export function getCodeCssAngular( { editorOptions, selectedInstallMethod }: GetCodeCssAngularArgs ): string {
	const groupedPlugins = groupByInstallPackage( editorOptions.editorPlugins );
	const hasPremiumPlugins = groupedPlugins[ 'ckeditor5-premium-features' ].length > 0;

	const snippetStyles = getCodeCss( { editorOptions } );
	const editorStylesImports = getStylesImport( selectedInstallMethod, hasPremiumPlugins )
		.split( '\n' )
		.filter( Boolean )
		.map( styleImport => '@' + styleImport );

	return [
		...editorStylesImports,
		snippetStyles
	].join( '\n' );
}
